import * as helper from './../../../../../VX/View/Assets/Js/helper';

export default class Counter {
	constructor() {
		this.counter = helper.$('#counter ul li');
		this.active = 0;
		this._addClass();
	}

	next() {
		this._removeClass();
		this.active++;
		this._addClass();
	}

	previous() {
		this._removeClass();
		this.active--;
		this._addClass();
	}

	_removeClass() {
		helper.removeClass(this.counter[this.active], 'active');
	}

	_addClass() {
		helper.addClass(this.counter[this.active], 'active');
	}


}
